import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment'; // Assuming standard angular structure

export interface RingoverCallRequest {
  toNumber: string;
}

export interface RingoverSmsRequest {
  toNumber: string;
  message: string;
}

import { RingoverContact } from '../models/ringover-contact.model';

@Injectable({
  providedIn: 'root'
})
export class RingoverService {
  private apiUrl = environment.casApiUrl + '/api/ringover'; // Adapt if your environment API URL is different

  constructor(private http: HttpClient) {}

  initiateCall(request: RingoverCallRequest): Observable<any> {
    return this.http.post(`${this.apiUrl}/call`, request);
  }

  sendSms(request: RingoverSmsRequest): Observable<any> {
    return this.http.post(`${this.apiUrl}/sms`, request);
  }

  getContacts(): Observable<RingoverContact[]> {
    return this.http.get<RingoverContact[]>(`${this.apiUrl}/contacts`);
  }

  syncContacts(): Observable<{message: string, count: number}> {
    return this.http.post<{message: string, count: number}>(`${this.apiUrl}/contacts/sync`, {});
  }
}
